import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import { DataGrid, GridCloseIcon } from "@mui/x-data-grid";
import { Visibility } from "@mui/icons-material";

// interface TableDialogProps {
//   open: boolean;
//   onClose: () => void;
//   table_data: GridRowsProp;
//   columns: GridColDef[];
//   name: string;
// }

const TableDialog
  // : React.FC<TableDialogProps> 
  = ({ open, onClose, table_data: tableData, columns, name }) => {
    // const columns: GridColDef[] = [
    //   { field: "id", headerName: "ID" },
    //   { field: "name", headerName: "Name" },
    //   { field: "age", headerName: "Age" },
    // ];

    return (
      <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
        <div className="flex justify-between items-center">
          <DialogTitle textTransform="capitalize">{name}</DialogTitle>
          <div>
            <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
              <GridCloseIcon />
            </IconButton>
          </div>
        </div>
        <DialogContent>
          <div style={{ width: "100%" }}>
            <DataGrid rows={tableData} columns={columns} />
          </div>
        </DialogContent>
      </Dialog>
    );
  };

// type Props = {
//   table_data: GridRowsProp;
//   columns: GridColDef[];
//   name: string;
// };

const FileViewer = ({ table_data, columns, name }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  return (
    <div>
      <IconButton color="inherit" onClick={handleOpenDialog}>
        <Visibility />
      </IconButton>
      <TableDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        table_data={table_data}
        columns={columns}
        name={name}
      />
    </div>
  );
};

export default FileViewer;
